import { render, staticRenderFns } from "./m-product-card.vue?vue&type=template&id=570e3ed6&scoped=true"
import script from "./m-product-card.vue?vue&type=script&lang=ts"
export * from "./m-product-card.vue?vue&type=script&lang=ts"
import style0 from "./m-product-card.vue?vue&type=style&index=0&id=570e3ed6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e3ed6",
  null
  
)

export default component.exports